import React from "react";
import { ContentsProps } from "../../../../types";

const CustomerTargets: React.FC<ContentsProps> = ({ data, isLoading }) => {
  if (isLoading) {
    return <div className="p-4">Loading...</div>;
  }

  const { total_target, total_customers, category_breakdown } =
    data.customer_targets;
  const progress = (total_customers / total_target) * 100;

  // Calculate total category targets
  const totalCategoryTargets = Object.values(category_breakdown).reduce(
    (sum: number, value: number) => sum + (value as number),
    0
  );

  return (
    <div className="w-full p-4 bg-white rounded-lg shadow">
      <h2 className="text-xl font-semibold mb-4">Customer Targets</h2>

      {/* Overall Progress */}
      <div className="mb-6">
        <div className="flex justify-between mb-2">
          <span className="text-xl  font-medium text-gray-900 md:4xl">
            {total_target}
          </span>
        </div>
      </div>

      {/* Category Breakdown */}
      <div className="mb-4">
        <h3 className="text-lg font-medium mb-3">Category Breakdown</h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {Object.entries(category_breakdown).map(([category, target]) => {
            const percentage =
              ((target as number) / totalCategoryTargets) * 100;
            return (
              <div key={category} className="border rounded-lg p-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-gray-700">Category {category}</span>
                  <span className="text-lg font-semibold">{target}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CustomerTargets;
